module.exports = __webpack_public_path__ + "static/media/call_sharing_screen.28ec62c8.svg";